import { useQuery, useMutation } from "react-query";
import { Activity, FirebaseActivity } from "../types";
import firebase from "firebase";
import { nanoid } from "nanoid";
const useActivities = () => {
  const { isLoading, error, data, refetch } = useQuery<Activity[]>(
    "activities",
    () =>
      firebase
        .firestore()
        .collection("activities")
        .get()
        .then((snapshot) => {
          const activities: Activity[] = [];
          snapshot.forEach((doc) => {
            const data = doc.data() as FirebaseActivity;
            activities.push({
              ...data,
              id: doc.id,
              startTime: data.startTime?.toMillis
                ? data.startTime.toMillis()
                : data.startTime,
              finishTime: data.finishTime?.toMillis
                ? data.finishTime.toMillis()
                : data.finishTime,
            } as Activity);
          });
          return activities;
        })
  );

  const { mutate: removeActivity } = useMutation(
    "activities",
    async (activId: string) => {
      await firebase
        .firestore()
        .collection("activities")
        .doc(activId)
        .delete()
        .then(() => refetch());
    }
  );

  const { mutate: addActivityToFirestore } = useMutation(
    "activities",
    async (variables: Activity) => {
      await firebase
        .firestore()
        .collection("activities")
        .doc(nanoid())
        .set({
          ...variables,
          startTime: new Date(variables.startTime),
          finishTime: new Date(variables.finishTime),
        })
        .then(() => refetch());
      return variables;
    }
  );

  return { isLoading, error, data, addActivityToFirestore, removeActivity };
};

export default useActivities;
